import ClientService from "../services/client-managment.service";
import { useState, Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import superClientServiceObj from "../services/super-client.service";
// import RefreshToken from "./RefreshToken";

const GetAllSuperClients = (props) => {
  //const [recallMthd, setMthdRcl] = useState(false);

  useEffect(() => {
    getClientsDropDown();
  }, []);
  const [clientName, setClientName] = useState();
  const [allClientsData, setAllClientsData] = useState();
  const { user: currentUser } = useSelector((state) => state.auth);

  const getClientsDropDown = () => {
    superClientServiceObj.getSuperClientList(true)
      .then((response) => {
        if (response.data.payload) {
          let data = response.data.payload;
          //data.shift();
          setAllClientsData(data);
          const clientNameVal = data.map((options) => {
            let val = "";
            if (options.id === currentUser.user.ClientId) {
              val = options.clientName;
              return val;
            } else return "";
          });

          const finalVal = clientNameVal.filter((x) => {
            return x !== "";
          });
          setClientName(finalVal);
        }
      })
      .catch((err) => {
        // if (err && err.response && err.response.status === 401) {
        //   (async () => {
        //     let resp = await RefreshToken();
        //     if (resp) setMthdRcl(true);
        //   })();
        // }
      });
  };
  return (
    <Fragment>
      {allClientsData && (
        <Fragment>
          {currentUser?.role.includes("Super admin") && (
            <select
              id="clientNameDD"
              className="form-control no-icon"
              onChange={props.superclientnamechangehandler}
            >
              {props.searchgriddata === "Y" && (
                <option value="">Select Super Client Ledger</option>
              )}
              {allClientsData.map((options) => (
                <option key={options.id} name={options.name} value={options.name} id={options.id} userId={options.userId}>
                  {options.name} 
                </option>
              ))}
            </select>
          )}
          {currentUser?.role.includes("Client admin") && (
            <input
              type="text"
              value={clientName}
              disabled="disabled"
              className="form-controls"
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default GetAllSuperClients;
